// import { QueueAtomRender } from "./QueueAtomRender";
import { HookAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';
import HELPER from '@/app/utils/HELPER';
import type { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';
declare let Liquid: any;

/**
 * ChildProductAtomRender
 */
export class ChildProductAtomRender extends HookAtomRender {
  public atom: GpChildProduct;

  /**
   * class AtomProductRender extends BaseAtomRender {
   * @param atom GpProduct
   */
  constructor(atom: GpChildProduct) {
    super(atom);
  }

  /**
   * override renderLiquid từ Atom
   * NOTE: getModuleHtmlByTemplate() trong gfModule
   * * Using cho cac case:
   * - (P) Title
   * - (P) Vendor
   * - (P) SKU
   * - (P) Description
   * - (P) Price
   * - (P) Stock Counter
   * - (P) Cart Button
   * - (P) View More
   * - (P) Image
   * - (P) Image List
   * - (P) Variants
   * - (P) Swatches
   * @param templateTmp template string
   * @param jsonData :any
   * @returns html string
   */
  async renderLiquid(templateTmp: string, jsonData?: any): Promise<string> {
    let template = HELPER.simpleHTMLEntities(templateTmp);
    const atomModel = this.getAtomModel();
    template = HELPER.replaceFields(atomModel.settings, template);
    if (jQuery.isEmptyObject(jsonData)) {
      jsonData = await this.loadProductData().catch((err) => {});
    }
    const { product } = jsonData;
    let html = '';
    const tmpl = Liquid.parse(template);
    html = tmpl.render({ product });
    return html;
  }
  /**
   * runtemplate
   * Using cho cac case:
   * - (P) Title
   * - (P) Vendor
   * - (P) SKU
   * - (P) Description
   * - (P) Price
   * - (P) Stock Counter
   * - (P) Cart Button
   * - (P) View More
   * - (P) Image
   * - (P) Image List
   * - (P) Variants
   * - (P) Swatches
   */
  async renderTemplate(): Promise<void> {
    let templateTmp = this.getAtomModel().html;
    templateTmp = this.renderSettings(templateTmp); // Render khung cho module và data cho module sử dụng
    this.get$el().html(templateTmp); // Cần render settings trước để có khung và các value mặc định(pid)
    const moduleId = this.atom.getModuleId();
    const $atomBk = this.get$divContentBk().find(this.atom.getIdBk());
    const $settings = $atomBk.find('.settings');
    let fields = [];
    try {
      let settingData = $settings.html();
      if (!settingData || !settingData.length) {
        settingData = '[]';
      }
      fields = jQuery.parseJSON(settingData);
    } catch (err) {
      HELPER.showNotify(err.name + ': Error in Snippet Settings JSON', 'error');
    }
    const jsonData = await this.loadProductData().catch((err) => {
      this.get$el().remove();
    });
    templateTmp = HELPER.replaceFields(fields, templateTmp);
    templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

    const moduleIdSlug = moduleId.toString().replace(/-/g, '');
    templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
    let html = '';
    html = await this.renderLiquid(templateTmp, jsonData); // render child and render liquid
    html = this.renderSettings(html); // Render render setting id module cho các html childs
    this.get$el().html(html);
  }
  /**
   * override render từ Atom
   * NOTE: loadDynamicData() trong gfModule
   * @returns data :any;
   * Using cho cac case:
   * - (P) Title
   * - (P) Vendor
   * - (P) SKU
   * - Ultimate Sales Boost
   * - WideBundle
   * - (P) File Upload
   * - (P) Description
   * - (P) Price
   * - (P) Stock Counter
   * - (P) Cart Button
   * - (P) View More
   * - (P) Image
   * - (P) Image List
   * - (P) Quantity
   * - (P) Variants
   * - (P) Swatches
   */
  async loadProductData(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let data = {};
      const isParentProduct = this.get$el().closest('[data-label="Product"]').length > 0;
      // const $input = this.get$el().find("input");
      if (isParentProduct) {
        const productId = this.get$el().closest('[data-label="Product"]').children('.module').attr('data-pid');
        const productData = HELPER.searchProductInList(productId);

        if (!jQuery.isEmptyObject(productData)) {
          data = {
            product: productData,
          };
          // data = jQuery.parseJSON(jsonHtml);
          if (!jQuery.isEmptyObject(data)) {
            // await sleep(1000);
            resolve(data);
          } else {
            this.get$el().remove();
            HELPER.showNotify('This field is dropped to Product only.', 'error');
          }
        }
      }
    });
  }
}
